<div class="container">
  <div class="landing">
    <section class="hero" id="hero">
      <div class="hero__image">
        <img src="../../../../assets/integrations/viber.svg" alt="Viber CRM">
      </div>
      <div class="hero__content">
        <h1 class="hero__title">{{ 'viber_page.hero_title' | translate }}</h1>
        <p class="hero__subtitle">{{ 'viber_page.hero_subtitle' | translate }}</p>
        <a [href]="environment.login_url">
          <app-button [title]="'viber_page.hero_button' | translate"></app-button>
        </a>
      </div>
      <div class="hero__scroll" (click)="scrollTo('features')">
        <app-icon>expand_more</app-icon>
      </div>
    </section>

    <section class="section-container" id="features">
      <h2 class="section-title">{{ 'viber_page.features_title' | translate }}</h2>
      <ul class="features-list">
        <li>{{ 'viber_page.feature_1' | translate }}</li>
        <li>{{ 'viber_page.feature_2' | translate }}</li>
        <!--        <li>{{ 'viber_page.feature_3' | translate }}</li>-->
        <li>{{ 'viber_page.feature_4' | translate }}</li>
        <li>{{ 'viber_page.feature_5' | translate }}</li>
        <li>{{ 'viber_page.feature_6' | translate }}</li>
        <li>{{ 'viber_page.feature_7' | translate }}</li>
      </ul>
    </section>

    <section class="section-container" id="advantages">
      <h2 class="section-title">{{ 'viber_page.ai_title' | translate }}</h2>
      <ul class="features-list">
        <li>{{ 'viber_page.ai_feature_1' | translate }}</li>
        <li>{{ 'viber_page.ai_feature_2' | translate }}</li>
        <li>{{ 'viber_page.ai_feature_3' | translate }}</li>
      </ul>
    </section>

    <app-interface-for-all></app-interface-for-all>

    <section class="section-container" id="audience">
      <h2 class="section-title">{{ 'viber_page.audience_title' | translate }}</h2>
      <ul class="audience-list">
        <li>{{ 'viber_page.audience_1' | translate }}</li>
        <li>{{ 'viber_page.audience_2' | translate }}</li>
        <li>{{ 'viber_page.audience_3' | translate }}</li>
        <li>{{ 'viber_page.audience_4' | translate }}</li>
      </ul>
    </section>

    <app-advantages></app-advantages>

    <app-reviews></app-reviews>

    <section class="section-container" id="faq">
      <h2 class="section-title">{{ 'viber_page.faq_title' | translate }}</h2>
      <div class="faq-list">
        @for (item of faqList; track $index) {
          <div class="faq-item">
            <h3 class="faq-question">{{ item.question | translate }}</h3>
            <p class="faq-answer">{{ item.answer | translate }}</p>
          </div>
        }
      </div>
    </section>


    <section class="section-container" id="notice">
      <h2 class="section-title">{{ 'viber.notice_title' | translate }}</h2>

      <div class="d-flex flex-column danger-background">
        <p class="">
          {{ 'viber.notice_1' | translate }}
        </p>
        <p>
          {{ 'viber.notice_2' | translate }}
        </p>
      </div>

      <div>
        <h1>{{ 'viber.rules_title' | translate }}:</h1>
        <ul class="rules-list">
          @for (rule of viberRules; track $index) {
            <li> {{ rule.rule | translate }}</li>
          }
        </ul>
      </div>
    </section>

    <app-integration-review
      [youtubeReviewLink]="'https://www.youtube.com/embed/MoIdWmpvyKs'"
      [youtubeReviewTitle]="'viber.title' | translate"
    ></app-integration-review>
  </div>
</div>
